import BaseModel from "../default/base-model";

export class Client extends BaseModel {
    id: number;
    name: string;
    sap_code: string;
    active: boolean;
    url: string;
    plant!: string;

    constructor() {
        super();
        this.id = 0;
        this.name = "";
        this.sap_code = ""
        this.active = true;
        this.url = "";
    }
}
